<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" data-title="SNS 회원가입" ref="header" :type="'empty'"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <div class="progress">
          <ol>
            <li><span>동의</span></li>
            <li class="on"><span>정보입력</span></li>
            <li><span>정보입력(선택)</span></li>
          </ol>
        </div>

        <section class="hr">
          <div class="titArea">
            <h2 class="titH3 normal">회원 정보 입력</h2>
          </div>

          <div class="formArea">
            <span class="label">이름</span>
            <input type="text" id="ipt4" class="ipt" title="이름 입력" value="" v-model="contInfo.customerName" />

            <span class="label">생년월일</span>
            <div class="setBirth type2">
              <input
                type="tel"
                class="ipt"
                maxlength="6"
                title="주민등록 앞 6자리 입력"
                placeholder=""
                v-model="contInfo.ssn"
                v-onlyNum
                nextTarget="backSsn"
                v-skipOfMax
              />
              <span class="sign" aria-hidden="true">-</span>
              <input type="tel" class="ipt" maxlength="1" title="주민등록 뒤 1자리 입력" placeholder="" v-model="backSsn" v-onlyNum id="backSsn" />
              <span class="sign" aria-hidden="true">******</span>
            </div>

            <span class="label">휴대폰번호</span>
            <div :class="'setAgency ' + [rvalue ? '' : 'selected']">
              <!-- 알뜰폰 선택 시 클래스추가 : selected -->
              <ul class="iptGroup iptBtn">
                <li>
                  <input
                    type="radio"
                    class="ipt"
                    name="rdosort"
                    id="agency_1"
                    checked="checked"
                    v-model="rvalue"
                    v-bind:value="1"
                    v-on:click="changeRdoData($event)"
                  />
                  <label for="agency_1">SKT</label>
                </li>
                <li>
                  <input type="radio" class="ipt" name="rdosort" id="agency_2" v-model="rvalue" v-bind:value="2" v-on:click="changeRdoData($event)" />
                  <label for="agency_2">KT</label>
                </li>
                <li>
                  <input type="radio" class="ipt" name="rdosort" id="agency_3" v-model="rvalue" v-bind:value="3" v-on:click="changeRdoData($event)" />
                  <label for="agency_3">LGU+</label>
                </li>
              </ul>
              <select class="ipt" id="agency_4" title="통신사 선택" v-model="svalue" v-on:change="changeSltData($event)">
                <option value="">알뜰폰</option>
                <option value="5">SK알뜰폰</option>
                <option value="6">KT알뜰폰</option>
                <option value="7">LGU+알뜰폰</option>
              </select>
            </div>
            <!--
            <div class="setPhone">
              <input
                type="tel"
                id="phone_2"
                class="ipt"
                title="휴대폰 번호 입력"
                placeholder="' - ' 없이 입력해주세요."
                value=""
                v-model="contInfo.cellNum"
                v-onlyNum
              />

              <button type="button" class="btn_s round s" @click="sendAuthNumber" v-show="!timeCheck">
                {{ authButtonTitle }}
              </button>
            </div>
            -->

            <div class="setAddr uiAct">
              <div class="iptWrap">
                <input
                  type="tel"
                  id="phone_2"
                  class="ipt notDel uiAct"
                  title="휴대폰 번호 입력"
                  placeholder="' - ' 없이 입력해주세요."
                  value=""
                  v-model="contInfo.cellNum"
                  v-onlyNum
                />
              </div>
              <button type="button" class="btn_g m" @click="sendAuthNumber" v-if="!timeCheck">{{ authButtonTitle }}</button>
              <button type="button" class="btn_g m" style="opacity: 0.6" v-else>인증완료</button>
            </div>

            <!--
            <div v-show="authTime > 0 && !timeCheck">
              <input type="tel" id="phone_3" class="ipt addTxt" title="인증번호 입력" v-model="authNum" v-onlyNum value="" />
              <span class="txt">
                유효시간
                <strong class="pointC1">{{ authTime | convertTimeToMS }}</strong>
                &nbsp;

                <button type="button" class="btn_s round s" @click="checkNumber">
                  확인
                </button>
              </span>
            </div>
            -->

            <div class="setAddr uiAct" v-show="authTime > 0 && !timeCheck">
              <div class="iptWrap addTxt">
                <input
                  type="tel"
                  id="phone_3"
                  class="ipt notDel uiAct"
                  title="휴대폰 번호 입력"
                  placeholder=""
                  value=""
                  v-model="authNum"
                  v-onlyNum
                />
                <span class="txt">
                  <strong class="pointC1">{{ authTime | convertTimeToMS }}</strong>
                </span>
              </div>
              <button type="button" class="btn_g m" @click="checkNumber">인증번호확인</button>
            </div>
          </div>

          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="nextStep">다음</button>
          </div>
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->

    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import { isEmpty, checkBackPeop, calcAge } from '@/common/common.function';
import MessagePop from '@/components/popup/MessagePop';
import { SET_JOIN_INFO } from '@/store/mutations.type';
import { AUTH_TIMEOUT, JOIN_AGE_CHECK, SERVICE_COMM_ERROR } from '@/store/message.type.js';

export default {
  name: 'snsJoinStep2',
  components: {
    MessagePop,
  },
  mounted() {
    this.request = this.$route.params.request;
    this.$store.commit(SET_JOIN_INFO, this.request);
    //console.log(this.$route);
  },
  data: function () {
    return {
      step: 1,
      insAddr: false,
      msg: '',
      messagePop: false,
      goFindID: false,

      //본인인증관련
      tr_id: '',
      authKey: null, //인증번호
      uniqueKey: null,
      count: null, //제한시간
      time: '3:00', //인증시간text
      authButtonTitle: '인증번호요청', // 인증번호 버튼명 ( 인증번호요청 / 재요청 )
      authTime: 0, // 초기 세팅 시간 테스트로 10초로 설정 원래는 180초
      authNum: null,
      countDown: {},
      timeCheck: false,
      backSsn: '', //주민번호 뒷자리
      yy: '',

      //유저정보
      localCode: ['Y', 'N'],
      sexCode: ['RCSB000M', 'RCSB00WM'],
      cellCode: ['MBCP0001', 'MBCP0002', 'MBCP0003', 'MBCP0005', 'MBCP0006', 'MBCP0007'],

      rvalue: 1,
      svalue: '',

      contInfo: {
        customerName: null,
        localUserYn: 'Y',
        ssn: null,
        sex: '1',
        userIdentityComp: '1',
        cellNum: null,
      },

      request: null,
    };
  },
  watch: {
    backSsn() {
      let data = checkBackPeop(this.backSsn);
      this.contInfo.sex = data._sex;
      this.contInfo.localUserYn = data._local;
      this.yy = data._yyyy;
    },
    authTime() {
      if (this.authTime == 0) {
        this.authButtonTitle = '인증번호요청'; // 버튼 타이틀 초기값으로 변경
        clearInterval(this.countDown); // 카운트다운 초기화
        this.errorCode = null; // API 통해 리턴 받은 에러 코드 값 초기화
        this.authKey = null; // 인증번호 입력란 초기화
        // this.authTime = 180;
        //this.authTime = 10; // 인증번호 시간 초기화
        this.msg = AUTH_TIMEOUT; // API 서버에서도 리턴해주지만 클라이언트 쪽에서 처리하기 위해 메세지 추가
        this.messagePop = true;
      }
    },
  },

  methods: {
    nextStep: function () {
      if (!this.timeCheck) {
        this.msg = '휴대폰 인증을 해주세요.';
        this.messagePop = true;
      } else {
        this.request.userInfo = {};
        this.request.userInfo.birth = this.yy + this.contInfo.ssn;
        this.request.userInfo.cellNum = this.contInfo.cellNum;
        this.request.userInfo.password = '';
        this.request.userInfo.sex = this.sexCode[this.contInfo.sex - 1];
        this.request.userInfo.userId = this.request.snsId;
        this.request.userInfo.userName = this.contInfo.customerName;
        console.log(this.request);
        this.$router.push({ name: 'snsJoinStep3', params: { request: this.request } });
      }
    },
    validate: function () {
      if (isEmpty(this.contInfo.customerName)) {
        this.msg = '이름을 입력해주세요.';
        setTimeout(() => {
          this.messagePop = true;
        }, 100);
        return false;
      }
      if (isEmpty(this.contInfo.ssn) || isEmpty(this.backSsn)) {
        this.msg = '생년월일을 입력해주세요.';
        setTimeout(() => {
          this.messagePop = true;
        }, 100);
        return false;
      }
      if (isEmpty(this.contInfo.cellNum)) {
        this.msg = '휴대폰번호를 입력해주세요.';
        setTimeout(() => {
          this.messagePop = true;
        }, 100);
        return false;
      }
      return true;
    },
    check: function () {
      // console.log(this.contInfo);
    },
    changeRdoData: function (evt) {
      // console.log(evt.target.value);
      this.svalue = '';
      this.rvalue = evt.target.value;
      this.contInfo.userIdentityComp = evt.target.value;
    },
    changeSltData: function (evt) {
      // console.log(evt.target.value);
      this.rvalue = '';
      this.svalue = evt.target.value;
      this.contInfo.userIdentityComp = evt.target.value;
    },
    //인증번호 요청
    sendAuthNumber: function () {
      if (!this.validate()) {
        return;
      } //데이터 체크
      // 만 14세 미만 체크
      if (calcAge(this.yy + this.contInfo.ssn) < 14) {
        this.msg = JOIN_AGE_CHECK;
        this.messagePop = true;
        return;
      }
      // API 호출
      ApiService.service(
        'POST',
        //http://211.232.100.58:3456/api/v1/common/sms/auth
        'external/verification',
        {
          request: {
            cellNum: this.contInfo.cellNum,
            customerName: this.contInfo.customerName,
            //orderId: this.request.orderCommInfo.orderId,
            sex: this.contInfo.sex,
            localUserYn: this.contInfo.localUserYn,
            ssn: this.yy + this.contInfo.ssn,
            userIdentityComp: this.contInfo.userIdentityComp,
          },
          serviceType: 'app',
        },
      )
        .then((response) => {
          // console.log(response.data);
          // console.log(response.data.isSucceed);
          if (response.data.isSucceed == false) {
            this.msg = response.data.error;
            this.messagePop = true;
            return false;
          }

          this.timeCheck = false;
          this.uniqueKey = response.data.result.uniqueKey;

          //시간
          this.authButtonTitle = '재요청'; // 인증 진행시 버튼 TITLE 변경
          this.authTime = 180;
          clearInterval(this.countDown); // 재 요청시 시간 초기화 필요
          this.countDown = setInterval(() => {
            this.authTime--;
          }, 1000);
        })
        .catch((response) => {
          console.log(response);
        });
    },
    checkNumber: function () {
      // API 호출
      ApiService.service(
        'PUT',
        //http://211.232.100.58:3456/api/v1/common/sms/auth
        'external/verification',
        {
          request: {
            authNum: this.authNum,
            cellNum: this.contInfo.cellNum,
            customerName: this.contInfo.customerName,
            //orderId: this.request.orderCommInfo.orderId,
            uniqueKey: this.uniqueKey,
            sex: this.contInfo.sex,
            localUserYn: this.contInfo.localUserYn,
            ssn: this.yy + this.contInfo.ssn,
            userIdentityComp: this.contInfo.userIdentityComp,
          },
          serviceType: 'app',
        },
      )
        .then((response) => {
          console.log(response.data);
          if (!isEmpty(response.data.error)) {
            this.msg = response.data.error; // API에서 response 해주는 message
            this.errorCode = response.data.errorCode; // API에서 response 해주는 errorCode
            this.messagePop = true;
          } else {
            // 페이지별 로직 처리
            // 가입 정보 Object 생성후 vuex로 저장

            document.getElementById('phone_2').disabled = true;
            this.step++;
            clearInterval(this.countDown);

            //가입 이력 확인
            ApiService.service('POST', 'user/snsAuthCheck', {
              request: {
                cellNum: this.contInfo.cellNum,
                userName: this.contInfo.customerName,
                birth: this.contInfo.ssn,
                requestKey: this.uniqueKey,
              },
              serviceType: 'app',
            })
              .then((response) => {
                console.log(response.data);
                if (response.data.isSucceed) {
                  let updateYN = response.data.result.infoUpdateYn;
                  let rentalYN = response.data.result.rentalYn;
                  let userYN = response.data.result.userYn;

                  if (userYN == 'Y') {
                    this.msg = '입력하신 인증정보로 웹몰에 이미 <br>가입된 정보가 확인됩니다. <br>아이디 찾기로 이동합니다.';
                    this.goFindID = true;
                    this.messagePop = true;
                  } else if (userYN == 'N' && rentalYN == 'Y' && updateYN == 'N') {
                    this.msg = '고객님은 이미 렌탈을 이용중인 이력이 <br>확인되어 정보를 연동했습니다.';
                    this.messagePop = true;
                  } else if (userYN == 'N' && rentalYN == 'Y' && updateYN == 'Y') {
                    this.msg =
                      '고객님은 이미 렌탈을 이용중인 이력이 <br>확인되어 정보를 연동했습니다. 렌탈가입 <br>당시의 휴대폰 번호와 본인인증 휴대폰 번호가 <br>상이하여 본인인증 휴대폰 번호로 <br>정보가 갱신되었습니다.';
                    this.messagePop = true;
                  } else {
                    this.msg = '휴대폰 본인인증이 <br>완료되었습니다.';
                    this.messagePop = true;
                  }

                  this.timeCheck = true;
                } else {
                  this.msg = SERVICE_COMM_ERROR;
                  this.messagePop = true;
                }
              })
              .catch((response) => {
                console.log(response);
              });
          }
        })
        .catch((response) => {
          console.log(response);
        });
    },
    close() {
      this.messagePop = false;
      if (this.goFindID) {
        this.$router.replace({
          name: 'findId',
        });
      }
    },
  },
};
</script>
